import React from "react";
import Grid from "@material-ui/core/Grid";
import RibbonsMain from "./awards/RibbonsMain";
import BadgeLevels from "./badges";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import clsx from "clsx";
import Achievements from "./achievements";
import Hidden from "@material-ui/core/Hidden";
import { useTranslation } from 'react-i18next';
import styles from "./AwardsMain.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const slickSliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  centerMode: true,
  centerPadding: "12px",
  slidesToShow: 1,
  slidesToScroll: 1,
  // responsive: [ { breakpoint: 550, settings: { slidesToShow: 1, variableWidth: false } } ],
  // variableWidth: true
  // variableWidth: true
  // adaptiveHeight: true,
  // className: styles.inner_slider,
  // dotsClass: clsx("slick-dots", styles.slick_dots_custom)
};

export default function AwardsMain(props) {
  const {
    ribbonsData,
    ribbonsCountData,
    //may need to fix badges compoent to accept null data
    dsAchievementResult,
    dsAchievementTotal,
    dsProfileDetails,
    usn,
    height = "500px"
  } = props;

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const tablet = useMediaQuery(theme.breakpoints.down("sm"));

  const badgeLevels = (
    <BadgeLevels
      RUSH_LEV={dsProfileDetails && dsProfileDetails.RUSH_LEV}
      ELITE_LEV={dsProfileDetails && dsProfileDetails.ELITE_LEV}
      SPECIAL_LEV={dsProfileDetails && dsProfileDetails.SPECIAL_LEV}
      SCOUTING_LEV={dsProfileDetails && dsProfileDetails.SCOUTING_LEV}
      SNIPER_LEV={dsProfileDetails && dsProfileDetails.SNIPER_LEV}
    />
  );

  const achievements = (
    <Achievements
      userAchievements={dsAchievementResult && dsAchievementResult}
      userTotal={dsAchievementTotal && dsAchievementTotal[0]}
    />
  );

  const ribbonsMain = (
    <RibbonsMain
      ribbonData={ribbonsData}
      countData={ribbonsCountData}
      height="100%"
    />
  );

  //i may have misunderstanding of how badges and achievements compoents work
  //can discuss with mark - but doing this for now
  return (
    <>
      <Hidden xsDown>
        <Grid
          container
          spacing={2}
          classes={{
            root: clsx(
              styles.container,
              tablet && styles.tablet,
              mobile && styles.mobile
            )
          }}
        >
          <Grid classes={{ root: clsx(styles.item) }} item sm={6} md={3}>
            {badgeLevels}
          </Grid>
          <Grid item sm={6} md={3}>
            {achievements}
          </Grid>
          <Grid item sm={12} md={6}>
            {ribbonsMain}
          </Grid>
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Slider {...slickSliderSettings}>
          <div className={clsx(styles.slider_item, mobile && styles.mobile)}>
            {badgeLevels}
          </div>
          <div className={clsx(styles.slider_item, mobile && styles.mobile)}>
            {achievements}
          </div>
          <div className={clsx(styles.slider_item, mobile && styles.mobile)}>
            {ribbonsMain}
          </div>
        </Slider>
      </Hidden>
    </>
  );
}
